export const call = {
  permission: {
    title: "カメラとマイクの許可が必要です",
    camera: "カメラへのアクセス",
    microphone: "マイクへのアクセス",
    description:
      "ビデオ通話を利用するには、ブラウザの設定でカメラとマイクのアクセスを許可してください。",
    descriptionNative: "設定画面から許可を変更できます。",
    openSettings: "設定を開く",
  },
  outgoing: {
    calling: "発信中",
    cancel: "キャンセル",
  },
  busy: {
    title: (args: { name: string | number }) => `${args.name}さんは通話中`,
    titleNoName: "お相手は通話中",
    description: "ただいま別の通話中のため、応答できません。",
    videoLabel: "ビデオ通話",
    voiceLabel: "音声通話",
    videoCallRequest: "ビデオ通話をリクエスト",
    voiceCallRequest: "音声通話をリクエスト",
    sendMessage: "メッセージを送る",
    close: "閉じる",
  },
  incoming: {
    videoCall: "ビデオ通話の着信",
    voiceCall: "音声通話の着信",
    accept: "応答",
    decline: "拒否",
  },
  controls: {
    speaker: "スピーカー",
    switchCamera: "カメラ切替",
    chat: "チャット",
    buyPoints: "ポイント購入",
    micOn: "マイクON",
    micOff: "マイクOFF",
    endCall: "通話終了",
  },
  endConfirm: {
    title: "通話を終了しますか？",
    cancel: "キャンセル",
    end: "終了",
  },
  ended: {
    normal: "通話が終了しました",
    partnerHangup: "相手が通話を終了しました",
    pointShortage: "ポイントが不足しています",
    networkError: "ネットワークエラーが発生しました",
    timeout: "応答がありませんでした",
    declined: "通話が拒否されました",
    // cancelled はモーダルを表示しない（型整合のために定義のみ）
    cancelled: "通話がキャンセルされました",
    streamConnectFailed: "相手に接続できませんでした",
    close: "閉じる",
  },
  endedModal: {
    favorite: "お気に入り",
    videoCallRequest: "ビデオ通話リクエスト（無料）",
    voiceCallRequest: "音声通話リクエスト（無料）",
    sendMessage: (args: { name: string | number }) =>
      `${args.name}さんにメッセージを送る`,
  },
  request: {
    duplicateError: "5分以内に同じ相手にリクエストを送ることはできません",
    error: "リクエストの送信に失敗しました",
    sent: "通話リクエストを送信しました",
    videoContent: (args: { name: string | number }) =>
      `ビデオ通話をリクエストしました✨\n${args.name}さん、ビデオ通話しましょう♪`,
    voiceContent: (args: { name: string | number }) =>
      `音声通話をリクエストしました✨\n${args.name}さん、音声通話しましょう♪`,
  },
  chat: {
    placeholder: "メッセージ...",
    send: "送信",
  },
  lovense: {
    button: "Lovense",
    menuTitle: "Lovenseメニュー",
    duration: "秒",
    points: "pt",
    types: {
      weak: "弱",
      medium: "中",
      strong: "強",
      pulse: "パルス",
      wave: "ウェーブ",
      fireworks: "花火",
      earthquake: "地震",
      cyclone: "サイクロン",
      tornado: "トルネード",
      meteor: "メテオ",
      full_control: "フルコントロール",
    },
    sentMessage: "送信しました",
    activating: "起動中",
    controlling: "コントロール中",
    remaining: "残り",
    intensity: "強度",
  },
} as const;
